<ng-container *transloco="let t">
  <app-editable-text
    appNavBreadcrumb
    [label]="productGroup()?.productGroupName ?? ''"
    [disable]="isReadOnly()"
    (textChange)="changeName($event)"
  />
  @if (productGroup() === null) {
    <div class="flex h-100 w-100 items-center justify-center">
      <div class="flex flex-col items-center">
        <h3 class="text-center">{{ t("product-group-page.product_group_not_found") }}</h3>
        <p class="text-center">{{ t("product-group-page.not_found_details") }}</p>
      </div>
    </div>
  } @else {
    <div class="mb-3">
      @if (!isReadOnly()) {
        <div class="flex justify-end gap-2">
          <button iButton variant="secondary" (click)="editMode.set(!editMode()); newAsins.set([])">
            <IIcon [name]="editMode() ? 'close' : 'edit'" />
            {{ editMode() ? t("common.close") : t("product-group-page.edit_asins") }}
          </button>
          @if (newAsins().length) {
            <button iButton size="md" (click)="updateProductGroupProducts(newAsins())">
              {{ t("common.save") }}
            </button>
          }
        </div>
      }
    </div>

    <div class="h-[70vh]">
      <app-asin-selection
        [selectedAsins]="editMode() ? alreadySelectedProducts()! : []"
        [customList]="editMode() ? undefined : alreadySelectedProducts()!"
        (selectedAsinsChange)="newAsins.set($event)"
        [csvExport]="false"
        [readonly]="!editMode() || isReadOnly()"
      />
    </div>
  }
</ng-container>
